<form style="width:25vw" [formGroup]="form">
  <div class="row">
    <div class="col-sm-12">
      <mat-form-field style="width: 100%">
        <mat-label i18n="Anzeigestufe@@NoteFacility_Filters_NoteDisplayLevel">DisplayLevel</mat-label>
        <mat-select formControlName="eventFilter">
          <mat-select-trigger>
            <mat-chip-set>
              <mat-chip>
                {{ getLabelForEventType(data.eventFilter) }}
              </mat-chip>
            </mat-chip-set>
          </mat-select-trigger>
          @for (entryType of entryTypeFiltersAvailable; track entryType) {
            <mat-option
              [value]="entryType.value"
              >
              {{entryType.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div mat-dialog-actions>
        <ctrl-btn-accept style="padding-right: 10px;"
                    [disabled]="
                        this.data.eventFilter === null ||
                        this.data.eventFilter === undefined
                    "
          [mat-dialog-close]="this.data"
        ></ctrl-btn-accept>
        <ctrl-btn-cancel style="padding-right: 10px;"
          (click)="onNoClick()"
        ></ctrl-btn-cancel>
      </div>
    </div>
  </div>
</form>